import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children, overlayHeader = false }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-sm focus:bg-gold focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-ink'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className={cn('flex-1', !overlayHeader && 'pt-20')}>
                {children}
            </main>

            <SiteFooter />

            <div aria-hidden='true' className='film-grain' />
        </div>
    )
}
